'use client';

import * as React from 'react';
import { styled } from '@linaria/react';

import useBoundingBox from '@/hooks/use-bounding-box';
import SquigglyLine from '@/components/SquigglyLine/SquigglyLine';

interface Props extends React.HTMLAttributes<HTMLSpanElement> {
  children: React.ReactNode;
}

function SquigglyUnderline({ children, ...delegated }: Props) {
  const ref = React.useRef(null);
  const bb = useBoundingBox(ref);

  return (
    <Wrapper {...delegated} ref={ref}>
      {bb && (
        <SquiggleWrapper>
          <ForegroundSquigglyLine
            squiggleWidth={5}
            width={bb.width}
            height={10}
          />
        </SquiggleWrapper>
      )}
      <TextWrapper>{children}</TextWrapper>
    </Wrapper>
  );
}

const Wrapper = styled.span`
  --color-squiggle: red;
  position: relative;
  font-weight: var(--font-weight-bold);
`;

const SquiggleWrapper = styled.span`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  transform: translateY(50%);
  pointer-events: none;
`;

const ForegroundSquigglyLine = styled(SquigglyLine)`
  stroke: oklch(0.68 0.3 357.41);
  stroke-width: 2;
  stroke-linecap: round;

  html[data-color-mode='dark'] & {
    stroke: oklch(0.83 0.2 77.44);
  }
`;

const TextWrapper = styled.span`
  position: relative;

  html[data-color-mode='light'] & {
    text-shadow:
      -2px 2px 0px var(--color-background),
      0px 2px 0px var(--color-background),
      2px 2px 0px var(--color-background);
  }
  html[data-color-mode='dark'] & {
    text-shadow:
      0 0 1px var(--color-background),
      0 0 2px var(--color-background),
      0 0 3px var(--color-background);
  }
`;

export default SquigglyUnderline;
